import type { PGRequestInterface } from 'store/performanceGuarantee/types';
import type {
  SimulationRequestInterface,
  SimulationResponseInterface,
  PerformanceGuaranteeResponseInterface,
} from 'store/simulation/types';
import { post } from 'api/apiClient';
import type {
  ChamberAnalysisRequestInterface,
  ChamberAnalysisResponseInterface,
} from 'store/chamberAnalysis/types';

const VERSION = 'v1';
const BASE_PATH = `simulation/${VERSION}`;

export async function simulate(body: SimulationRequestInterface) {
  return post<SimulationResponseInterface>(
    `${BASE_PATH}/simulate`,
    JSON.stringify(body),
  );
}

export async function chamberAnalysis(body: ChamberAnalysisRequestInterface) {
  return post<ChamberAnalysisResponseInterface>(
    `${BASE_PATH}/ca`,
    JSON.stringify(body),
  );
}

export async function performanceGuarantee(req: PGRequestInterface) {
  return post<PerformanceGuaranteeResponseInterface>(
    `${BASE_PATH}/pg`,
    JSON.stringify(req),
  );
}
